<template>
  <div>
    <div class="lengends">
      <ul class="colorClass">
        <li v-for="(item, index) in $parent.$parent.result.IPOTrend.industries" :key="index">
          <div class="lengendicon" @click="showLine(index)"/>
          <div class="lengendtext">
            <span :class="{ graycolortext: dataSelect[index] === false }" class="lengendanme"
                  @click="showLine(index)">{{ item | lengthFormate }}</span>
            <span class="lengenddelete" @click="deleteLine(index)"><i class="el-icon-close"></i></span>
          </div>
        </li>
        <div style="clear: both"></div>
      </ul>
    </div>
    <div id="box" style="width: 100%; height: 400px; margin-left: -28px;"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  data() {
    return {
      dataSelect: [true, true, true, true, true],
      myChart: null
    };
  },
  filters: {
    lengthFormate(value) {
      if (value && value !== '' && value.length > 30) {
        return value.substring(0, 30) + '...'
      }
      return value
    }
  },
  methods: {
    showLine(index) {
      this.dataSelect[index] = !this.dataSelect[index];
      var temparr = this.dataTopFive;
      this.dataTopFive = [];
      this.dataTopFive = temparr;
      var option = this.myChart.getOption();
      let ifShow = option.legend[0].selected;
      if (JSON.stringify(ifShow) === "{}") {
        let name = this.$parent.$parent.result.IPOTrend.industries[index];
        option.legend[0].selected = {[name]: false};
        echarts.init(document.getElementById("box")).setOption(option);
      } else {
        let name = this.$parent.$parent.result.IPOTrend.industries[index];
        if (typeof ifShow[name] == "undefined") {
          option.legend[0].selected = {[name]: false};
          echarts.init(document.getElementById("box")).setOption(option);
        } else {
          if (ifShow[name]) {
            option.legend[0].selected = {[name]: false};
            echarts.init(document.getElementById("box")).setOption(option);
          } else {
            option.legend[0].selected = {[name]: true};
            echarts.init(document.getElementById("box")).setOption(option);
          }
        }
      }
    },
    deleteLine(index) {
      const option = this.myChart.getOption();
      this.$parent.$parent.result.IPOTrend.industries.splice(index, 1);
      option.series.splice(index, 1);
      this.myChart.clear();
      this.myChart.setOption(option);
    },
    drawLine() {
      const series = [];
      for (let i = 0; i < this.$parent.$parent.result.IPOTrend.lineData.length; i++) {
        series.push({
          name: this.$parent.$parent.result.IPOTrend.industries[i],
          data: this.$parent.$parent.result.IPOTrend.lineData[i],
          type: "line",
          smooth: true,
          symbol: "none"
        })
      }
      if (this.myChart != null) {
        this.myChart.dispose()
      }
      // 基于准备好的dom，初始化echarts实例，所以只能在mounted中调用
      this.myChart = echarts.init(document.getElementById("box"));
      this.myChart.clear()
      window.onresize = this.myChart.resize
      this.myChart.setOption({
        title: {
          text: '',
          subtext: 'Articles',
          left: '3%'
        },
        color: ["#c23531", "#389AFE", "#FFA500", "#1eff00", "#238E68"],
        tooltip: {
          trigger: "axis",
          textStyle: {fontSize: "14",},
          formatter: function (params) {
            var res = "" + params[0].name;
            for (var i = 0, l = params.length; i < l; i++) {
              if (i == 0) {
                res +=
                    '<br/><span style="color:#c23531;float: left;">' + params[i].seriesName + "</span>" +
                    '<span style="margin-left:20px;float: right;">' + params[i].value[1] + "</span>";
              } else if (i == 1) {
                res +=
                    '<br/><span style="color:#389AFE;float: left;">' + params[i].seriesName + "</span>" +
                    '<span style="margin-left:20px;float: right;">' + params[i].value[1] + "</span>";
              } else if (i == 2) {
                res +=
                    '<br/><span style="color:#FFA500;float: left;">' + params[i].seriesName + "</span>" +
                    '<span style="margin-left:20px;float: right;">' + params[i].value[1] + "</span>";
              } else if (i == 3) {
                res +=
                    '<br/><span style="color:#1eff00;float: left;">' + params[i].seriesName +
                    "</span>" + '<span style="margin-left:20px;float: right;">' + params[i].value[1] + "</span>";
              } else if (i == 4) {
                res +=
                    '<br/><span style="color:#238E68;float: left;">' + params[i].seriesName +
                    "</span>" + '<span style="margin-left:20px;float: right;">' + params[i].value[1] + "</span>";
              }
            }
            return res;
          },
        },
        legend: {show: false,},
        grid: {left: "3%", right: "4%", bottom: "3%", containLabel: true,},
        xAxis: {
          type: "category",
          data: this.$parent.$parent.result.IPOTrend.dates,
          axisTick: {show: false},
          boundaryGap: false
        },
        yAxis: {type: "value", splitLine: {show: false}},
        series: series
      })
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>

/** {
  vertical-align: middle;
}*/

.lengends ul li {
  float: left;
  display: flex;
  cursor: pointer;
  align-items: center;
  margin: 0 30px 10px 0;
}

.lengends ul {
  margin-left: 15px;
}

.lengendicon {
  height: 18px;
  width: 18px;
  border-radius: 50%;
}

.colorClass {
  :nth-child(1) > .lengendicon {
    background: #c23531;
  }

  :nth-child(2) > .lengendicon {
    background: #389afe;
  }

  :nth-child(3) > .lengendicon {
    background: #ffa500;
  }

  :nth-child(4) > .lengendicon {
    background: #1eff00;
  }

  :nth-child(5) > .lengendicon {
    background: #238e68;
  }

  :nth-child(6) > .lengendicon {
    background: #ccc;
  }
}

.graycolortext {
  color: #ccc;
}

.lengendtext {
  font-size: 12px;
  color: rgb(127, 127, 127);
  margin-left: 10px;
  padding: 1px 10px;
  border: 1px solid #ccc;
  border-radius: 20px;
}

.lengendtext .lengenddelete {
  font-size: 14px;
}

.lengendtext .lengenddelete {
  margin-left: 10px;
}
</style>